// QR customer-facing pages only (namespace: "qr"). Draft — review the French.
const qr_fr = {
  add: "Ajouter",
  additional_info: "Informations supplémentaires",
  all: "Tout",
  amount: "Montant",
  basket: "Panier",
  basket_empty: "Votre panier est vide !",
  calories: "Calories",
  cancel: "Annuler",
  cart: "Panier",
  change_mode: "Changer de mode",
  customer_name: "Nom du client",
  done: "Terminé",
  failed_to_load_order_history:
    "Échec du chargement de l'historique des commandes",
  failed_to_load_products: "Échec du chargement des produits",
  home: "Accueil",
  how_would_you_like_to_order: "Comment souhaitez-vous commander ?",
  insufficient_quantity: "Quantité insuffisante",
  items: "Articles",
  menu: "Menu",
  no: "Non",
  no_menu_data_found: "Aucune donnée de menu trouvée",
  options: "Options",
  order_confirmed: "Commande confirmée",
  order_id: "N° de commande",
  order_placed_successfully: "Votre commande a été passée avec succès !",
  order_with_ai: "Commander avec l'IA",
  order_yourself: "Commander vous-même",
  out_of_stock: "Rupture de stock",
  place_new_order: "Passer une nouvelle commande",
  place_order: "Passer la commande",
  please_scan_valid_qr_code_or_try_again_later:
    "Veuillez scanner un code QR valide ou réessayer plus tard.",
  search_product_name_here: "Rechercher un produit ici",
  select_language: "Choisir la langue",
  select_options: "Sélectionner les options",
  selected_item: "Article sélectionné",
  skip: "Passer",
  something_went_wrong: "Une erreur s'est produite",
  status: "Statut",
  subtotal: "Sous-total",
  successfully_added: "Ajouté avec succès",
  taxes: "Taxes",
  total: "Total",
  touch_screen: "Écran tactile",
  validate_customer_name_required: "Le nom du client est obligatoire.",
  validate_vehicle_color_required: "La couleur du véhicule est obligatoire.",
  validate_vehicle_number_required: "Le numéro du véhicule est obligatoire.",
  vehicle_color: "Couleur du véhicule",
  vehicle_number: "Numéro du véhicule",
  view_details: "Voir les détails",
  voice_assistant: "Assistant vocal",
  voice_connection_error: "Erreur de connexion vocale. Veuillez réessayer.",
  voice_session_inactive:
    "L'assistant vocal s'est arrêté après une pause. Appuyez sur le micro pour recommencer.",
  voice_session_time_limit:
    "L'assistant vocal a atteint sa limite de temps. Appuyez sur le micro pour recommencer.",
  warning_empty_basket:
    "Êtes-vous sûr de vouloir supprimer ces produits du panier ?",
  welcome_to: "Bienvenue chez",
  yes: "Oui",
  your_order: "Votre commande",

  // Voice assistant UI (options modal + floating button status) and footer.
  available_options: "Options disponibles",
  voice_options_instruction:
    "Dites les options souhaitées ou dites « aucune » pour passer",
  voice_initializing: "Initialisation…",
  voice_tap_to_start: "Appuyez pour démarrer",
  voice_listening: "À l'écoute… (appuyez pour mettre en pause)",
  voice_speaking: "Parle… (appuyez pour mettre en pause)",
  voice_added_to_cart: "Ajouté au panier",
  voice_removed: "Supprimé",
  voice_order_placed: "Commande passée !",
  voice_active: "Actif (appuyez pour mettre en pause)",
  powered_by: "Propulsé par",
  voice_product_not_found:
    "Désolé, je n'ai pas trouvé « {{product}} » dans notre menu.",
  voice_product_out_of_stock:
    "Désolé, {{product}} est en rupture de stock.",
  voice_options_prompt:
    "Souhaitez-vous des options avec {{product}} ? Disponibles : {{options}}. Dites « non » ou « aucune » pour passer, ou indiquez les options souhaitées.",
  voice_stock_limited:
    "Désolé, il ne reste que {{available}} {{product}} en stock.",
  voice_added_quantity_to_cart:
    "{{quantity}} {{product}}{{options}} ajouté(s) à votre panier.",
  voice_item_not_in_cart: "« {{product}} » n'est pas dans votre panier.",
  voice_removed_quantity:
    "{{quantity}} {{product}} retiré(s) de votre panier.",
  voice_cart_contents: "Votre panier contient : {{items}}.",
  voice_with_options: " avec {{options}}",
  voice_cart_empty_submit:
    "Votre panier est vide. Ajoutez des articles avant de valider.",
  voice_failed_to_place_order:
    "Échec de la commande. Veuillez réessayer.",
  voice_order_error:
    "Une erreur s'est produite lors de votre commande. Veuillez réessayer.",
  our_store: "Notre boutique",
  currency_riyals: "riyals saoudiens",
  voice_order_success:
    "Votre commande a été passée avec succès ! Numéro de commande : {{orderId}}. Merci pour votre commande !",
};

export default qr_fr;
